import { render, staticRenderFns } from "./ErrorSubmitForm4.vue?vue&type=template&id=77f0fc1e&scoped=true"
import script from "./ErrorSubmitForm4.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f0fc1e",
  null
  
)

export default component.exports